export default __webpack_public_path__ + "static/5-9172250c26444e3b64cf9e438a102c8f.jpg";